import { client } from 'core/api'

export const getConnectionStatus = () => {
  return client.fetch({
    method: 'get',
    path: '/line/user-connection-status',
  })
}
